<template>
  <div>
    <h1 class="page-header">{{ $t('termsemester.termsemester') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('termsemester.fromBranch')
                }}</label>
                <div class="col-md-8">
                  <select
                    class="form-control"
                    disabled
                    :class="{ 'is-invalid': errors.has('branch_id') }"
                    v-model.number="model.from_branch_id"
                  >
                    <option value="">{{ $t('select') }}</option>
                    <option
                      v-for="(br, index) in branchs"
                      :key="index"
                      :value="br.value"
                    >
                      {{ br.label }}
                    </option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.has('branch_id')">
                    {{ errors.first('branch_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('termsemester.toBranch')
                }}</label>
                <div class="col-md-8">
                  <select
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('branch_id') }"
                    v-model.number="model.to_branch_id"
                  >
                    <option value="">{{ $t('select') }}</option>
                    <option
                      v-for="(br, index) in branchs"
                      :key="index"
                      :value="br.value"
                    >
                      {{ br.label }}
                    </option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.has('branch_id')">
                    {{ errors.first('branch_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('termsemester.academicYear')
                }}</label>
                <div class="col-md-8">
                  <select
                    class="form-control"
                    disabled
                    :class="{ 'is-invalid': errors.has('ac_year_id') }"
                    v-model.number="model.ac_year_id"
                    @change="getTermOrder"
                  >
                    <option value="">{{ $t('select') }}</option>
                    <option
                      v-for="(acYear, index) in acYears"
                      :key="index"
                      :value="acYear.ac_year_id"
                    >
                      {{ acYear.ac_year }}
                    </option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.has('ac_year_id')">
                    {{ errors.first('ac_year_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('termsemester.subProgram')
                }}</label>
                <div class="col-md-8">
                  <select
                    class="form-control"
                    v-model.number="model.acps_id"
                    disabled
                    :options="subPrograms"
                    @change="getTermOrder"
                  >
                    <option
                      v-for="(sub, index) in subPrograms"
                      :key="index"
                      :value="sub.value"
                    >
                      {{ sub.text }}
                    </option>
                  </select>
                  <div class="validate" v-if="errors.has('acps_id')">
                    {{ errors.first('acps_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-form-label col-md-3 required">{{
                  $t('termsemester.academicTerm')
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model="model.term_name"
                    disabled
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('term_name') }"
                    :placeholder="$t('termsemester.enteracademicterm')"
                  />
                  <div class="invalid-feedback" v-if="errors.has('term_name')">
                    {{ errors.first('term_name') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-form-label col-md-3 required">
                  {{ $t('termsemester.academicTermOrder') }}
                  <i
                    class="fas fa-spinner fa-pulse label-loading"
                    v-if="pull_term_order"
                  ></i>
                </label>
                <div class="col-md-8">
                  <input
                    v-model.number="model.term_order"
                    disabled
                    type="text"
                    class="form-control-plaintext"
                    :placeholder="$t('termsemester.academictermorder')"
                    readonly
                  />
                  <div class="validate" v-if="errors.has('term_order')">
                    {{ errors.first('term_order') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('termsemester.startDate')
                }}</label>
                <div class="col-md-8">
                  <ts-date-picker-input
                    v-model="model.term_start"
                    disabled
                  ></ts-date-picker-input>
                  <div class="validate" v-if="errors.has('term_start')">
                    {{ errors.first('term_start') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-3 col-form-label required">{{
                  $t('termsemester.stopDate')
                }}</label>
                <div class="col-md-8">
                  <ts-date-picker-input
                    v-model="model.term_stop"
                    disabled
                  ></ts-date-picker-input>
                  <div class="validate" v-if="errors.has('term_stop')">
                    {{ errors.first('term_stop') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 text-right">
              <hr />
              <ts-button
                class="btn-primary mr-2"
                @click.prevent="store"
                :waiting="waiting_save"
              >
                {{ $t('save') }}
              </ts-button>
              <ts-button
                class="btn-default"
                @click.prevent="$router.push({ name: 'term-semester' })"
              >
                {{ $t('cancel') }}
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'termSemesterCopyTerm',
  data() {
    return {
      errors: new Errors(),
      waiting_save: false,
      waiting_save_new: false,
      pull_term_order: false,
      branchs: [],
      model: {
        from_branch_id: '',
        to_branch_id: '',
        ac_year_id: '',
        acps_id: '',
        term_name: '',
        term_start: '',
        term_stop: '',
        term_order: ''
      }
    }
  },
  created() {
    this.selectDefaultCurrentYear()
    this.setEditData()
    this.getBranch()
  },
  computed: {
    ...mapState('termSemester', ['acYears', 'edit_data']),
    subPrograms() {
      return this.$store.state.termSemester.subPrograms.map(el => ({
        value: el.acps_id,
        text: el.acps_name_foreign
      }))
    }
  },
  methods: {
    selectDefaultCurrentYear() {
      if (this.acYears.length > 0) {
        let currentYear = this.acYears.filter(y => y.ac_status_id == 1)
        if (currentYear[0]) {
          this.model.ac_year_id = currentYear[0].ac_year_id
        }
      }
    },
    store() {
      this.waiting_save = true
      this.$store
        .dispatch('termSemester/copyTerm', this.model)
        .then(response => {
          this.waiting_save = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'term-semester' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting_save = false
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    getTermOrder() {
      if (this.model.acps_id && this.model.ac_year_id) {
        this.pull_term_order = true
        this.$store
          .dispatch('termSemester/getTermOrder', {
            acYearId: this.model.ac_year_id,
            acpsId: this.model.acps_id
          })
          .then(response => {
            this.model.term_order = parseInt(response.term_order)
            this.pull_term_order = false
          })
      } else {
        this.model.term_order = ''
        this.$toasted.info('Please select academic year and sub program')
      }
    },
    setEditData() {
      this.model = {
        from_branch_id: this.edit_data.branch_id,
        to_branch_id: this.edit_data.branch_id,
        ac_year_id: this.edit_data.ac_year_id,
        acps_id: this.edit_data.acps_id,
        term_name: this.edit_data.term_name,
        term_start: this.edit_data.term_start,
        term_stop: this.edit_data.term_stop,
        term_order: this.edit_data.term_order
      }
    }
  }
}
</script>
